"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GroupedAppts = void 0;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _framerMotion = require("framer-motion");
var _button = _interopRequireDefault(require("@kyruus/button"));
var _ArrowDown = _interopRequireDefault(require("@kyruus/react-ikons/ArrowDown"));
var _intl = require("@kyruus/intl");
var _Banners = require("../../Banners");
var _styles = require("./styles");
var _utils = require("../../../lib/utils");
var _ApptList = require("./ApptList.utils");
var _messages = _interopRequireDefault(require("../../../lib/messages"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const variants = {
  initial: {
    y: '-20%',
    opacity: 0
  },
  enter: {
    y: 0,
    opacity: 1
  },
  exit: {
    y: '20%',
    opacity: 0
  },
  open: {
    opacity: 1,
    height: 'auto',
    visibility: 'visible'
  },
  collapsed: {
    opacity: 0,
    height: 0,
    transitionEnd: {
      visibility: 'hidden'
    }
  }
};
const stickyHeaders = {
  header: {
    date: '155px',
    location: '196px'
  },
  mobileHeader: {
    date: '200px',
    location: '242px'
  }
};
const AnimatedList = /*#__PURE__*/_react.default.forwardRef((props, ref) => /*#__PURE__*/_react.default.createElement(_styles.List, (0, _extends2.default)({}, props, {
  variants: variants,
  initial: "open",
  exit: "exit",
  ref: ref
})));
AnimatedList.displayName = 'AnimatedList';
const propTypes = {
  header: _propTypes.string.isRequired,
  groupByLocId: _propTypes.object.isRequired,
  // {locationId: Array<slots>}
  locById: _propTypes.object.isRequired,
  // {locationId: location}
  onSelectAppt: _propTypes.func.isRequired,
  onHighlightLocId: _propTypes.func.isRequired,
  query: _propTypes.object.isRequired,
  // current query object {patientRel, purpose, role, periodStart...}
  shouldUseJumpToDate: _propTypes.bool,
  apptDensity: (0, _propTypes.oneOf)(['default', 'dense']),
  disableExpandCollapse: _propTypes.bool,
  track: _propTypes.func,
  shouldShowRegulatedSpacesBanner: _propTypes.bool,
  provider: _propTypes.object.isRequired,
  intl: (0, _propTypes.shape)({
    formatMessage: _propTypes.func.isRequired
  }).isRequired
};
const GroupedAppts = _ref => {
  var _context;
  let {
    header,
    groupByLocId,
    locById,
    onSelectAppt,
    onHighlightLocId,
    query,
    shouldUseJumpToDate,
    apptDensity,
    disableExpandCollapse = false,
    track = () => {},
    shouldShowRegulatedSpacesBanner = false,
    provider,
    intl
  } = _ref;
  const isVirtualVisit = (0, _utils.hasAnyVideoPhoneAppt)(query.purpose.visit_method);
  const [isVisible, setShowAppts] = (0, _react.useState)(true);
  const refs = (0, _react.useRef)((0, _map.default)(_context = isVirtualVisit ? ['0'] : (0, _keys.default)(groupByLocId)).call(_context, () => /*#__PURE__*/(0, _react.createRef)()));
  // show/hide each list section when `isVisible` changes
  (0, _react.useEffect)(() => {
    var _context2;
    (0, _forEach.default)(_context2 = refs.current).call(_context2, ref => {
      if (ref.current) {
        const el = ref.current;
        el.style.maxHeight = isVisible ? `${el.scrollHeight}px` : 0;
      }
    });
  }, [isVisible]);
  const mappedApptSlotsData = isVirtualVisit ? (0, _ApptList.sortedVirtualSlotsByTime)(groupByLocId) // final result array of objects (grouped location id's data with sort by time)
  : (0, _keys.default)(groupByLocId); // final result object of objects (location id's data)
  const slotsTile = (slots, intl) => {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: "GroupedAppt",
      "data-testid": "GroupedAppts__Slot",
      key: slots.start_datetime,
      onFocus: () => onHighlightLocId(slots.location_id.toString()),
      onBlur: () => onHighlightLocId(null),
      onMouseEnter: () => onHighlightLocId(slots.location_id.toString()),
      onMouseLeave: () => onHighlightLocId(null)
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      id: (0, _utils.getApptSlotId)(slots),
      mode: apptDensity === 'dense' ? 'primary' : 'flat',
      onClick: () => onSelectAppt(slots),
      "aria-label": intl.formatMessage(_messages.default.ariaProviderTimeSlotDescription, {
        providerName: (0, _utils.formatProviderName)(provider),
        date: (0, _utils.formatHeaderDate)(header),
        time: (0, _utils.formatApptTime)(slots.start_datetime)
      })
    }, (0, _utils.formatApptTime)(slots.start_datetime)));
  };
  return /*#__PURE__*/_react.default.createElement(_styles.ApptContainer, {
    "data-testid": "GroupedAppts",
    isVirtualVisit: isVirtualVisit
  }, /*#__PURE__*/_react.default.createElement(_styles.Header, {
    className: "GroupedAppts__header" // used for PMC-specific styling adjustments
    ,
    "data-testid": "GroupedAppts__header",
    stickyValues: shouldUseJumpToDate && stickyHeaders,
    disableExpandCollapse: disableExpandCollapse
  }, /*#__PURE__*/_react.default.createElement("h5", null, (0, _utils.formatHeaderDate)(header)), !disableExpandCollapse && /*#__PURE__*/_react.default.createElement(_styles.ArrowButton, {
    "aria-label": isVisible ? 'hide appointments' : 'show appointments',
    mode: "flat",
    onClick: () => setShowAppts(!isVisible),
    reversed: !isVisible
  }, /*#__PURE__*/_react.default.createElement(_ArrowDown.default, {
    size: "24px"
  }))), /*#__PURE__*/_react.default.createElement(_framerMotion.AnimatePresence, null, isVirtualVisit ? /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(AnimatedList, {
    ref: refs.current[0],
    key: header,
    "data-testid": "GroupedAppts__Group__List",
    animate: isVisible ? 'open' : 'collapsed',
    apptDensity: apptDensity
  }, (0, _map.default)(mappedApptSlotsData).call(mappedApptSlotsData, locId => slotsTile(locId, intl)))) : (0, _map.default)(mappedApptSlotsData).call(mappedApptSlotsData, (locId, index) => {
    var _context3;
    return /*#__PURE__*/_react.default.createElement("div", {
      key: locId
    }, /*#__PURE__*/_react.default.createElement(_styles.ListHeader, {
      disableExpandCollapse: disableExpandCollapse,
      className: "GroupedAppts__Group__header" // used for PMC-specific styling adjustments
      ,
      "data-testid": "GroupedAppts__Group__header",
      stickyValues: shouldUseJumpToDate && stickyHeaders
    }, /*#__PURE__*/_react.default.createElement("div", {
      "data-testid": "location__name"
    }, locById[locId].name), /*#__PURE__*/_react.default.createElement("div", {
      "data-testid": "location__address"
    }, (0, _utils.formatLocation)(locById[locId])), locById[locId].facility_fee && shouldShowRegulatedSpacesBanner && /*#__PURE__*/_react.default.createElement(_Banners.RegulatedSpacesBanner, {
      "data-testid": "GroupedAppts__RegulatedSpacesBanner",
      location: locById[locId],
      track: track
    })), /*#__PURE__*/_react.default.createElement(AnimatedList, {
      ref: refs.current[index],
      key: header,
      "data-testid": "GroupedAppts__Group__List",
      animate: isVisible ? 'open' : 'collapsed',
      apptDensity: apptDensity
    }, (0, _map.default)(_context3 = groupByLocId[locId]).call(_context3, appt => slotsTile(appt, intl))));
  })));
};
exports.GroupedAppts = GroupedAppts;
GroupedAppts.propTypes = propTypes;
var _default = exports.default = (0, _intl.injectIntl)(GroupedAppts);
GroupedAppts.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "GroupedAppts",
  "props": {
    "disableExpandCollapse": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "track": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "shouldShowRegulatedSpacesBanner": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "header": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "groupByLocId": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": true
    },
    "locById": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": true
    },
    "onSelectAppt": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "onHighlightLocId": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "query": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": true
    },
    "shouldUseJumpToDate": {
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "apptDensity": {
      "description": "",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'default'",
          "computed": false
        }, {
          "value": "'dense'",
          "computed": false
        }]
      },
      "required": false
    },
    "provider": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": true
    },
    "intl": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "formatMessage": {
            "name": "func",
            "required": true
          }
        }
      },
      "required": true
    }
  }
};